import React, { useEffect, useState } from 'react';
import './cookiePopup.css';
import Button from '../Button';

export const CookiePopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Проверяем, было ли уже принято согласие
  useEffect(() => {
    const isCookieAccepted = localStorage.getItem('cookieAcceptedBelayaHotel');
    if (!isCookieAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    // Сохраняем в localStorage с timestamp
    const cookieData = {
      accepted: true,
      timestamp: new Date().toISOString(),
      expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString() // +1 год
    };

    localStorage.setItem('cookieAcceptedBelayaHotel', JSON.stringify(cookieData));
    setIsVisible(false);

    // Опционально: можно запустить скрипты аналитики после принятия
    initializeAnalytics();
  };

  const initializeAnalytics = () => {
    // Здесь можно инициализировать Google Analytics, Yandex.Metrica и т.д.
    console.log('Cookie accepted, initializing analytics...');

    // Пример для Google Analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }

    // Пример для Yandex.Metrica
    if (window.ym) {
      // Код инициализации Яндекс.Метрики
    }
  };

  // Проверяем, истекло ли согласие (например, через год)
  // const isConsentExpired = (cookieData) => {
  //   if (!cookieData || !cookieData.expires) return true;
  //   return new Date() > new Date(cookieData.expires);
  // };

  if (!isVisible) return null;

  return (
    <div id="cookie-popup" className="cookiePopup">
      <div className="cookiePopupContent">

        <h2 className="cookiePopupTitle">Мы используем файлы cookie</h2>

        <p className="cookiePopupText">
          Сайт использует файлы cookie для эффективной работы. Продолжая использование
          сайта, вы соглашаетесь с использованием файлов cookie.{' '}
          {/* <a 
            className="cookiePopupLink" 
            href=""
            target="_blank" 
            rel="noopener noreferrer"
          >
            Узнать&nbsp;подробнее.
          </a> */}
        </p>


        <Button onClick={handleAccept} variant="primary">
          Хорошо
        </Button>
      </div>
    </div>
  );
};